export default "__VITE_ASSET__TV64Qm5Q__"